var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","small":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({attrs:{"small":_vm.small,"color":_vm.color()}},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.icon())+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.verbage()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }